export default function normalizePrice(price: string): string | null {
    let matches = price.match(/\$(\d{1,3}(?:,\d{3})*(?:\.\d{1,2})?)/);
    return matches
        ? matches.slice(1).join("").replace(/,/g, "")
        : price.replace(/,/g, "");
}


// WEBPACK FOOTER //
// ./ClientApp/utils/normalizePrice.ts